"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

/**
 * @package
 * A consistent object that is passed to "onLegendClick" handlers for n-series charts
 *
 * @param {object} options - The object containing the properties passed to the constructor
 * @param {MwVisualizations~UpdateHiddenSeriesIndicesChart} options.chart - An MW Visualizations Chart instance that implements the "updateHiddenSeriesIndices" function
 * @param {string} options.seriesName - The name of the series that is being passed to the click event
 */
var NSeriesLegendClickOptions = function NSeriesLegendClickOptions(_ref) {
  var chart = _ref.chart,
      seriesName = _ref.seriesName;
  (0, _classCallCheck2.default)(this, NSeriesLegendClickOptions);

  if ((0, _typeof2.default)(chart) !== 'object') {
    throw new TypeError("chart must be provided as an object. Provided: ".concat(chart));
  }

  if (typeof chart.updateHiddenSeriesIndices !== 'function') {
    throw new TypeError("chart must contain an \"updateHiddenSeriesIndices\" method. Provided: ".concat(chart.updateHiddenSeriesIndices));
  }

  if (seriesName) {
    _argumentContracts.default.assertString(seriesName, 'seriesName');
  }

  this.chart = chart;
  this.seriesName = seriesName || '';
  Object.freeze(this);
};

exports.default = NSeriesLegendClickOptions;